module.exports = __webpack_public_path__ + "img/headerimg.294fa206.png";